import _ from "lodash";
import generateContentDataObject from "../../../../helpers/editor/generateContentDataObject";
import { isKeyValue } from "../../../../helpers/isKeyValue";
import { stringifyObjectsAndNumbers } from "../stringifyObjectsAndNumbers";
import { addDefaultValuesToItems } from "./updaterFunctions.ts/addDefaultValuesToItems";
import { addNewItem } from "./updaterFunctions.ts/addNewItem";
import { deleteEmptyItems } from "./updaterFunctions.ts/deleteEmptyItems";
import { deleteItem } from "./updaterFunctions.ts/deleteItem";
import { getIdAndPosition } from "./updaterFunctions.ts/getIdAndPosition";
import { getIsItemNew } from "./updaterFunctions.ts/getIsItemNew";
import { getOriginalItem } from "./updaterFunctions.ts/getOriginalItem";
import { pushFromItem } from "./updaterFunctions.ts/pushFromItem";
import { sortItemsByPosition } from "./updaterFunctions.ts/sortItemsByPosition";

const generator = new generateContentDataObject();

const particleGetModifiedValues = (modifiedItem) => {
  const [itemId, itemPosition] = getIdAndPosition(modifiedItem);
  const itemText = stringifyObjectsAndNumbers(modifiedItem.TEXT) || "";
  const itemUrl = stringifyObjectsAndNumbers(modifiedItem.URL) || "";
  const itemTarget = stringifyObjectsAndNumbers(modifiedItem.TARGET) || "_self";
  let itemGroup = modifiedItem.GROUP_ID;
  if (typeof itemGroup !== "number") {
    itemGroup = 0;
  }
  return {
    itemId,
    itemPosition,
    itemText,
    itemUrl,
    itemTarget,
    itemGroup,
  };
};

const particleModifyOriginalItem = (
  componentData,
  originalItem,
  modifiedItem,
  itemPosition,
  itemText,
  itemUrl,
  itemTarget,
  itemGroup
) => {
  if ("POSITION_IN_ARRAY" in modifiedItem) {
    originalItem.POSITION_IN_ARRAY = itemPosition;
    componentData.list.content.items.forEach((item) => {
      if (
        item.POSITION_IN_ARRAY === itemPosition &&
        item.READONLY_ID !== originalItem.READONLY_ID
      ) {
        pushFromItem(componentData.list.content.items, item);
      }
    });
  }
  if ("TEXT" in modifiedItem) {
    originalItem.title = itemText;
  }
  if ("URL" in modifiedItem) {
    originalItem.href = itemUrl;
  }
  if ("TARGET" in modifiedItem) {
    originalItem.isTargetBlank = itemTarget === "_blank";
  }
  if ("GROUP_ID" in modifiedItem) {
    const groupIndex = componentData.list.content.groups.findIndex(
      (group) => group.READONLY_ID === itemGroup
    );
    if (groupIndex === -1) {
      originalItem.groupIndex = 0;
    } else {
      originalItem.groupIndex = groupIndex;
    }
  }
};

export const updateListItems = (componentData, completionContent) => {
  if (!("ITEMS" in completionContent)) {
    return;
  }
  if (!Array.isArray(completionContent.ITEMS)) {
    if (completionContent.ITEMS === null) {
      componentData.list.content.items = [];
    }
    return;
  }
  completionContent.ITEMS.forEach((modifiedItem) => {
    if (!isKeyValue(modifiedItem) || !("READONLY_ID" in modifiedItem)) {
      return;
    }
    const {
      itemId,
      itemPosition,
      itemText,
      itemUrl,
      itemTarget,
      itemGroup,
    } = particleGetModifiedValues(modifiedItem);
    if (itemPosition === null) {
      componentData.list.content.items = deleteItem(
        componentData.list.content.items,
        itemId
      );
      return;
    }
    const isItemNew = getIsItemNew(componentData.list.content.items, itemId);
    if (isItemNew) {
      const newItem = generator.createListItemContentObject();
      newItem.title = "";
      newItem.href = "";
      addNewItem(
        componentData.list.content.items,
        newItem,
        itemId,
        itemPosition
      );
    }
    const originalItem = getOriginalItem(
      componentData.list.content.items,
      itemId
    );
    particleModifyOriginalItem(
      componentData,
      originalItem,
      modifiedItem,
      itemPosition,
      itemText,
      itemUrl,
      itemTarget,
      itemGroup
    );
  });
  sortItemsByPosition(componentData.list.content.items);
};
